import { apiClient } from './client';

export interface CertificateCodeResponse {
  code: string;
}

export interface CertificateVerificationResponse {
  valid: boolean;
  venueName?: string;
  venueAddress?: string;
  email?: string;
  subscriptionStatus?: string;
  periodStart?: string;
  periodEnd?: string;
  reason?: string;
}

export interface CertificateDataResponse {
  venueName: string;
  venueAddress?: string;
  email: string;
  isValid: boolean;
  subscriptionStatus: string;
  periodStart?: string;
  periodEnd?: string;
  verifyUrl: string;
  verificationCode: string;
}

export const certificatesApi = {
  /**
   * Get verification code for current user
   */
  getMyCertificate: async (): Promise<CertificateCodeResponse> => {
    const response = await apiClient.get<CertificateCodeResponse>('/certificates/my');
    return response.data;
  },

  /**
   * Verify a certificate by short code (public)
   */
  verifyCertificate: async (code: string): Promise<CertificateVerificationResponse> => {
    const response = await apiClient.get<CertificateVerificationResponse>(
      `/certificates/verify/${code}`
    );
    return response.data;
  },

  /**
   * Get certificate data for rendering (public)
   */
  getCertificateData: async (code: string): Promise<CertificateDataResponse> => {
    const response = await apiClient.get<CertificateDataResponse>(
      `/certificates/data/${code}`
    );
    return response.data;
  },

  /**
   * Download certificate as PDF (returns blob)
   */
  downloadCertificate: async (lang: string = 'en'): Promise<Blob> => {
    const response = await apiClient.get('/certificates/download', {
      params: { lang },
      responseType: 'blob',
    });
    return response.data;
  },
};
